// @flow
import React, { Component } from "react";
import { withCookies } from "react-cookie";
import moment from "moment";
import { DASHBOARD_BASE_URL } from "../../../../Constants/Global/apiConstants";

type PropsType = {
  cookies: Object,
  authInfos: Object,
  languages: Object,
  translate: string => void
};

type StateType = {};

class LoginCompleted extends Component<PropsType, StateType> {
  componentDidMount = () => {
    this._handleCookie();
    this._handleRedirect();
  };

  _handleCookie = () => {
    const token = this.props.authInfos.token;
    const activeLanguage = this.props.languages.filter(language => language.active)[0].code;

    const envanteriumCookie = this.props.cookies.get("envanterium");

    const expirationDate = new Date(
      moment()
        .add(2, "months")
        .format()
    );

    if (!envanteriumCookie) {
      this._setCookie(token, activeLanguage, expirationDate);
    } else {
      if (envanteriumCookie.token !== token || envanteriumCookie.activeLanguage !== activeLanguage) {
        this._setCookie(token, activeLanguage, expirationDate);
      }
    }
  };

  _setCookie = (token, activeLanguage, expirationDate) => {
    this.props.cookies.set(
        "envanterium",
        { token, activeLanguage },
        { path: "/", expires: expirationDate, domain: process.env.REACT_APP_COOKIE_DOMAIN }
    );
  };

  _handleRedirect = () => {
    setTimeout(() => {
      window.location = DASHBOARD_BASE_URL;
    }, 1000);
  };

  render() {
    const { translate } = this.props;
    return (
      <div>
        <p className="mb-3 text-center text-success">
          <i className="fas fa-check-circle fa-4x" />
        </p>
        <p className="mb-5 text-center">{translate("LoginLocale.completed.content")}</p>
      </div>
    );
  }
}

export default withCookies(LoginCompleted);



// WEBPACK FOOTER //
// ./src/Components/PublicAccountPages/Components/Login/LoginCompleted.js